import React, { useId } from "react";
import OrganizerPillSelect from "../components/OrganizerPillSelect";

export const PERIOD_OPTIONS = [
  { value: "last7", label: "Últimos 7 días" },
  { value: "last30", label: "Últimos 30 días" },
  { value: "last90", label: "Últimos 90 días" },
  { value: "month", label: "Este mes" },
  { value: "prevMonth", label: "Mes anterior" },
];

export const COMPARE_OPTIONS = [
  { value: "prev", label: "Período anterior" },
  { value: "yoy", label: "Mismo período del año pasado" },
  { value: "none", label: "Sin comparar" },
];

/**
 * The two filters every statistics screen shares: the period and what to compare it with.
 * @param {{period: string, compare: string}} filters
 * @param {(patch: object) => void} onChange
 */
export const periodFields = (filters, onChange) => [
  { key: "period", label: "Período", value: filters.period, options: PERIOD_OPTIONS, onChange: (period) => onChange({ period }) },
  { key: "compare", label: "Comparar con", value: filters.compare, options: COMPARE_OPTIONS, onChange: (compare) => onChange({ compare }) },
];

// One filter: a visible label and the panel dropdown (OrganizerPillSelect). The dropdown trigger is
// named "<label> <selected option>" through aria-labelledby, so screen readers hear both.
function Field({ label, value, onChange, options, allLabel }) {
  const uid = useId();
  const labelId = `${uid}-label`;
  const choices = allLabel ? [{ value: "all", label: allLabel }, ...options] : options;
  return (
    <div className="stats-field">
      <span id={labelId} className="stats-field__label">
        {label}
      </span>
      <OrganizerPillSelect id={`${uid}-trigger`} labelledBy={labelId} value={value} onChange={onChange} options={choices} />
    </div>
  );
}

/**
 * Filter row shared by the statistics screens. Controlled: the page owns the values and decides which
 * filters exist (a club selector only with several clubs, the professional filter not for a linked
 * professional...).
 *
 * @param {{fields: Array<{key: string, label: string, value: string, onChange: (value: string) => void,
 *   options: Array<{value: string, label: string}>, allLabel?: string}>, children?: React.ReactNode}} props
 *   `allLabel` prepends an "all" option (value "all"); `children` renders extra actions at the end.
 */
export default function StatsFilters({ fields, children }) {
  return (
    <section className="stats-filters" aria-label="Filtros">
      {fields.map(({ key, ...field }) => (
        <Field key={key} {...field} />
      ))}
      {children}
    </section>
  );
}
